import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ModalData {
  description: string;
  leftButtonText: string;
  rightButtonText: string;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public modalData: ModalData) {}

  ngOnInit(): void {}
}
